module.exports = __webpack_public_path__ + "img/card-banner-1.002aa874.png";